"use client";


// CUSTOM ICON COMPONENTS
import appIcons from "icons";


// ==============================================================


// ==============================================================

export default function IconComponent({
  icon,
  ...props
}) {
  if (!icon || typeof icon === "undefined") return null;
  const Icon = appIcons[icon];
  return <Icon {...props} />;
}